import Appointment from "./Appointment";

export default Appointment;
